<template>
	<div class="row">
		<div class="col-md-12">

			<template data-vv-scope="form-create">
				<div class="row">
					<div class="col-md-6">
						<div class="form-group" :class="{ 'has-danger': errors.has('name') }">
							<input type="text" v-validate="'required'" v-model="name" name="name" class="form-control" placeholder="Add new name">
							<span class="error form-control-feedback" v-if="errors.first('name')">{{errors.first('name')}}</span>
						</div>
					</div>
					<div class="col-md-6">
						<template v-if="selected.id !== undefined">
							<el-button type="primary" :loading="submitting" @click="update">Update</el-button>
							<a class="btn btn-danger" :disabled="submitting" @click="cancel">Cancel</a>
						</template>
						<template v-else>
							<el-button type="primary" :loading="submitting" @click="create">Create</el-button>
						</template>
					</div>
				</div>

				<div class="row">
					<div class="col-md-6">
						<div class="form-group" :class="{ 'has-danger': errors.has('email') }">
							<input type="email" v-validate="'required|email'" v-model="email" name="email" class="form-control" placeholder="Add new e-mail">
							<span class="error form-control-feedback" v-if="errors.first('email')">{{errors.first('email')}}</span>
						</div>
					</div>
				</div>
			</template>

			<div class="row">
				<div class="col-md-6">
					<div class="form-group">
						<input @keyup="get(1)" v-model="search" type="text" class="form-control pull-left" style="width:200px;" placeholder="Search Contact"> &nbsp;
	                    <button @click="get(1)" class="btn btn-warning"><i class="fa fa-refresh"></i></button>
					</div>
				</div>
				<div class="col-md-12">
					<el-table
						:data="contacts"
						border
						v-loading.body="loading"
						style="width: 100%;">
						<el-table-column prop="name" label="Name" width="200" :show-overflow-tooltip="true"></el-table-column>
						<el-table-column prop="email" label="Email" :show-overflow-tooltip="true"></el-table-column>
						<el-table-column label="Operations" width="150">
							<template scope="scope">
								<a class="btn btn-xs btn-primary btn-xtra-small" @click="edit(scope.row)">
									<i class="fa fa-pencil"></i>
								</a>
								<a class="btn btn-xs btn-danger btn-xtra-small" @click="remove(scope.row)">
									<i class="fa fa-trash"></i>
								</a>
							</template>
						</el-table-column>
					</el-table>
					<el-pagination
                        :total="pagination.total"
                        layout="total, prev, pager, next, sizes"
                        :current-page="pagination.current_page"
                        @current-change="fetchPaginate"
                        :page-size="limit"
                        @size-change="handleSizeChange"
                        :page-sizes="[5, 10, 15, 20, 25, 30, 50]"
                        >
                    </el-pagination>
				</div>
			</div>

		</div>
	</div>
</template>

<script>
	
	import {Pagination} from 'element-ui'
	import swal from 'sweetalert2'

	export default{
		props:['load'],
		data(){
			return {
				contacts:[],
				pagination:[],
				submitting:false,
				loading:false,
				limit:10,
				page:1,
				name:'',
				email:'',
				search:'',
				selected:{}
			}
		},
		components: {
			'el-pagination': Pagination
		},
		watch:{
			'limit': function(){
				this.get()
			}
		},
		methods: {
			fetchPaginate: function(page){
                if(this.page != page) {
                    this.page = page
                    this.get()
                }
            },
            handleSizeChange: function(size){
                this.limit = size
            },
			create: function(){
				this.$validator.validateAll('form-create').then(success => {
                    if (success) {
                        this.submitting = true

						this.$http.post(process.env.API_ENDPOINT + '/contacts?token=' + this.$cookies.get('teltonika_session'), {
							name:this.name,
							email:this.email
						}).then((response) => {
	                    	this.$notify({
		                        title: 'Success',
		                        message: 'Contact added',
		                        type: 'success',
		                        duration: 3000
		                    })
	                        this.submitting = false
	                        this.clear()
	                        this.get()
		                }, (response) => {
		                	if(response.status == 422){
		                		this.$notify({
			                        title: 'Error',
			                        message: response.statusText,
			                        type: 'error',
			                        duration: 3000
			                    })

		                		let vm = this
			                    $.each(response.body, function(key, val){
			                    	vm.errors.add(key, val[0])
			                    })

		                	}else{
		                		this.$notify({
			                        title: 'Error',
			                        message: 'Something went wrong!',
			                        type: 'error',
			                        duration: 3000
			                    })
		                	}

		                    this.submitting = false
		                })
                    }
                })
			},
			update: function(){
				this.$validator.validateAll('form-create').then(success => {
                    if (success) {
                        this.submitting = true

						this.$http.put(process.env.API_ENDPOINT + '/contacts/' + this.selected.id +'?token=' + this.$cookies.get('teltonika_session'), {
							name:this.name,
							email:this.email,
							id:this.selected.id
						}).then((response) => {
	                    	this.$notify({
		                        title: 'Success',
		                        message: 'Contact updated',
		                        type: 'success',
		                        duration: 3000
		                    })
	                        this.submitting = false
	                        this.selected = {}
	                        this.clear()
	                        this.get()
		                }, (response) => {
		                	if(response.status == 422){
		                		this.$notify({
			                        title: 'Error',
			                        message: response.statusText,
			                        type: 'error',
			                        duration: 3000
			                    })

		                		let vm = this
			                    $.each(response.body, function(key, val){
			                    	vm.errors.add(key, val[0])
			                    })

		                	}else{
		                		this.$notify({
			                        title: 'Error',
			                        message: 'Something went wrong!',
			                        type: 'error',
			                        duration: 3000
			                    })
		                	}

		                    this.submitting = false
		                })
                    }
                })
			},
			clear: function(){
				this.name = ''
				this.email = ''
			},
			get: function(page = this.page){
				this.loading = true

				let filters = ''

				filters += '&limit=' + this.limit
                
                filters += '&page=' + page

                if(this.search !== ''){
                    filters += '&search=' + this.search
                }

				this.$http.get(process.env.API_ENDPOINT + '/contacts?token=' + this.$cookies.get('teltonika_session') + filters).then((response) => {
					this.contacts = response.body.data
                  	this.pagination = response.body
                  	this.loading = false
                }, (response) => {
                  console.log(response)
                  this.loading = false
                })
			},
			remove: function(item){
				let vm = this
				swal({
                    title: 'Are you sure?',
                    text: 'You won\'t be able to revert this',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes'
                }).then(function () {
                    vm.submitting = true
                    vm.$http.delete(process.env.API_ENDPOINT + '/contacts/' + item.id + '?token=' + vm.$cookies.get('teltonika_session')).then((response) => {
                        vm.$notify({
	                        title: 'Success',
	                        message: 'Contact Deleted',
	                        type: 'success'
                        })
                        vm.submitting = false
                        vm.get()
	                }, (response) => {
	                  vm.submitting = false
	                  if (response.data.message) {
	                    vm.$notify({
	                        title: 'Error',
	                        message: response.data.message,
	                        type: 'error'
	                    })
	                  }
	                })
                }, function(dismiss){
                   
                })
			},
			edit: function(item){
				this.selected = Object.assign({}, item)
				this.name = this.selected.name
				this.email = this.selected.email
			},
			cancel: function(item){
				this.selected = {}
				this.clear()
			}
		},
		created(){
			this.get()
		}
	}

</script>


// WEBPACK FOOTER //
// contact-list.vue?06360cb9